import { Button, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { StyledInputBase as BaseInput } from "components/Input/styled";

export const ItemContainer = styled("div")(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  marginBottom: "36px",
}));

export const OuterContainer = styled("div")(({ theme }) => ({
  backgroundColor: "#FFFFFF",
  borderRadius: theme.shape.borderRadius,
  height: "100%",
  width: "100%",
}));

export const Row = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
}));
export const Col = styled("div")(({ theme }) => ({
  width: "100%",
}));

export const BalanceSheetContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "auto",
  display: "grid",
  gridTemplateColumns: "63% 32%",

  [theme.breakpoints.down("md")]: {
    display: "block",
  },
  [theme.breakpoints.down("sm")]: {
    display: "block",
  },
  justifyContent: "space-between",
  marginBottom: "100px",
}));

export const SettingContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: theme.shape.borderRadius,
  gridTemplateRows: "10% 80% 10%",
}));

export const TitleSection = styled(Typography)(({ theme }) => ({
  height: "55px",
  display: "flex",
  alignItems: "center",
  padding: "0 24px 0 24px",
}));

export const MiddleSection = styled(Typography)(({ theme }) => ({
  minHeight: "400px",
  padding: "40px",
  margin: "0 24px",
  borderRadius: theme.shape.borderRadius,
  borderWidth: "1px",
  borderColor: "#cacaca",
  borderStyle: "solid",
}));

export const ActionSection = styled(Typography)(({ theme }) => ({
  display: "flex",
  padding: "0 24px",
  height: "120px",
  flexDirection: "column",
  justifyContent: "space-evenly",
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  height: "44px",
  fontSize: "16px",
}));

export const CarouselContainer = styled("div")(({ theme }) => ({
  cursor: "pointer",
  marginBottom: "36px",
  position: "relative",
}));

export const CarouselLayer = styled("div")(({ theme }) => ({
  position: "absolute",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#d6dbe26a",
  zIndex: 2,
}));

export const FactorSettingInfoContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));

export const StyledInputBase = styled(BaseInput)(({ theme }) => ({
  width: "80%",
}));

export const FactorSectionItem = styled("div")(({ theme }) => ({
  height: "12%",
}));

export const TitleItem = styled(FactorSectionItem)(({ theme }) => ({
  borderBottom: `1px solid #ABBACC`,
  minHeight: "40px",
}));

export const StyledListItemButton = styled(ListItemButton)(
  ({ theme, active }: { theme?: ThemeObjType; active?: boolean }) => ({
    height: "50px",
    margin: "8px 0 8px 0",
    padding: "12px",
    backgroundColor: active ? "none" : "#F9FBFC",
    "&:hover": {
      backgroundColor: "#EBF0FF52",
    },
  })
);

export const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: "30px",
});

export const StyledListItemText = styled(ListItemText)({
  textAlign: "right",
});

export const SubItem = styled("div")({
  display: "flex",
  padding: "12px",
  alignItems: "center",
});

export const SubListItemText = styled(ListItemText)({
  paddingRight: "12px",
});

export const MiddleTitleSection = styled("div")(({ theme }) => ({
  padding: "16px",
  height: "50px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

export const NavigationContainer = styled("div")(({ theme }) => ({
  padding: "12px",
  height: "40px",
  position: "relative",
  borderRadius: "4px",
  backgroundColor: "#F3F4F5",
  alignItems: "center",
  margin: "24px 16px 0 16px",
  display: "flex",
  justifyContent: "space-between",
}));

export const NavigationItem = styled("div")(({ theme }) => ({
  display: "flex",
  height: "30px",
  width: "80px",
  alignItems: "center",
  cursor: "pointer",
  justifyContent: "space-evenly",
  zIndex: 2,
}));

export const Thumb = styled("div")(
  ({ theme, rightPosition }: { theme?: ThemeObjType; rightPosition?: number }) => ({
    position: "absolute",
    right: rightPosition || 0,
    backgroundColor: "white",
    top: "3px",
    borderRadius: "4px",
    zIndex: 1,
    height: "34px",
    width: "80px",
    transition: "all 0.3s",
  })
);

export const ListItems = styled("div")(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  padding: "10px",
}));
export const ListItem = styled("div")(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
}));

export const StyledTable = styled("table")(() => ({
  width: "100%",
  border: "1px solid #E8E8E8 ",
}));
export const Th = styled("th")(() => ({
  padding: "5px 10px",
}));
export const Td = styled("td")(() => ({
  padding: "5px 10px",
}));
